/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { itemSkeletonCSS, avatarSkeletonCSS, labelSkeletonCSS } from './search-skeleton.styled';
export var SkeletonItem = function SkeletonItem(_ref) {
  var _ref$avatarShape = _ref.avatarShape,
    avatarShape = _ref$avatarShape === void 0 ? 'none' : _ref$avatarShape,
    width = _ref.width,
    isShimmering = _ref.isShimmering,
    textHeight = _ref.textHeight;
  var avatarShapes = Array.isArray(avatarShape) ? avatarShape : [avatarShape];
  return (
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    jsx("div", {
      css: itemSkeletonCSS
    }, avatarShape !== 'none' ?
    // eslint-disable-next-line react/no-array-index-key
    avatarShapes.map(function (shape, idx) {
      return (
        // @ts-ignore
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        jsx("span", {
          key: idx,
          css: avatarSkeletonCSS(shape, isShimmering)
        })
      );
    }) : null, jsx("span", {
      css: labelSkeletonCSS(width, isShimmering, textHeight)
    }))
  );
};